import CreateFundraiserPage from "src/pages/Fundraiser/CreatePage";
export default CreateFundraiserPage;
